import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import * as uuid from 'uuid';
import { mensaService } from '../../gestione-mensa.service';
import { HtmlEditorService, QuickToolbarService, ToolbarService, ToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';

@Component({
  selector: 'app-programmazione-edit',
  templateUrl: './programmazione-edit.component.html',
  styleUrls: ['./programmazione-edit.component.css'],
  providers: [MessageService,ToolbarService, HtmlEditorService, QuickToolbarService]

})
export class ProgrammazioneEditComponent implements OnInit {
  @ViewChild('maintablepranzo') maintablepranzo:any;
  @ViewChild('maintablecena') maintablecena:any;
  
  backUrl:string='dashboard/gestionemensa/programmazione';
  action:any='';
  camerasList:any=[];
  loading:boolean = true;
  selectedItems:any[]=[];
  elencoPiattiPranzo: any = [];
  struttureList: any = [];
  ricetteList:any[]=[];
  ricetteListAll:any[]=[];
  struttura_id:number=0;
  pageTitle:string='';
  progr:any={
    struttura_id:17,
    giorno:null,
    stato:'NON CONFERMATO',
    note:'',
    pranzo:[],
    cena:[]
  };
  
  public tools: ToolbarSettingsModel = {
    type: 'Expand' as ToolbarSettingsModel['type'],
    items: ['Bold', 'Italic', 'Underline', 'OrderedList',
        'UnorderedList']};

  statoprogrammaListi=[
    {label:'NON CONFERMATO', value: 'NON CONFERMATO'},
    {label:'CONFERMATO', value: 'CONFERMATO'},
   
  ];

  tipopiattiList=[];
  

  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public router: Router,
    private mensaservice: mensaService,
  ) { }


  ngOnInit(): void {
  
    this.tipopiattiList=this.mensaservice.getTipiPiatti(); 
    this.action=this.route.snapshot.paramMap.get('action');
    this.progr.struttura_id=this.route.snapshot.paramMap.get('struttura_id');
    this.struttura_id=this.progr['struttura_id'];

    this.pageTitle=this.route.snapshot.paramMap.get('struttura_name');
  
    if(this.route.snapshot.paramMap.get('id')){
    
      this.apiService.post('mensa/mensa_programmazione_getall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
        this.progr = data2.Result[0];
        this.progr['giorno']=new Date(this.progr['giorno']);
       
        this.apiService.get('checklists/checkl_getstrutture',{}).subscribe((data)=>{
          this.struttureList=data.Result;
          let f=this.struttureList.filter((x)=>x.value==this.struttura_id);
          this.pageTitle=' '+f[0].text;
        });
        this.apiService.post('mensa/mensa_ricette_getall',{struttura_id:this.struttura_id}).subscribe(data2 => {
          this.ricetteListAll=data2.Result;
          this.ricetteList =[{
            label:'',
            value: 0
          }];
          data2.Result.forEach((r) => {
            this.ricetteList.push({
              label:r.nome,
              value: r.id
            })
          });
       
          this.loading=false;
        });
      });
    } else {
      this.apiService.post('mensa/mensa_ricette_getall',{struttura_id:this.struttura_id}).subscribe(data2 => {
        this.ricetteListAll=data2.Result;
        this.ricetteList =[{
          label:'',
          value: 0
        }];
        data2.Result.forEach((r) => {
          this.ricetteList.push({
            label:r.nome,
            value: r.id
          })
        });
     
        this.loading=false;
      });
    }

    
  }

  valida(){
    return true;
  }

  salva(){
    this.apiService.post('mensa/mensa_programmazione_update',this.progr).subscribe(data => {
      this.addSingle('success', 'Successo', 'Record aggiornato ');
      this.router.navigateByUrl(this.backUrl);
    });
  }
  
  delete(){

  }

  annulla(){
    this.router.navigateByUrl(this.backUrl);
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }


  onRowEditCancelPranzo(ev:any){

  }
 deleteSezionePranzo(ev:any,list:any){
    
    list.forEach((c:any,ind:number)=>{
      if(c.id==ev.id){
        list.splice(ind,1);
      }
    });
   
  }
  onRowEditSavePranzo(ev:any){
    
  }
  onRowEditSaveCena(ev:any){
    
  }
  
  onRowEditInitCena(ev:any){
    
  }
  onRowEditInitPranzo(ev:any){
    
  }
  caricaRicetta(pp:any){
    
    let f=this.ricetteListAll.filter((x:any)=> x.id==pp.ricetta_id);
    if((f)&&(f.length>0)){
      pp.nome=f[0].nome;
      pp.tipo=f[0].tipo;
      pp.ingredienti=f[0].ingredienti;
      pp.allergeni=f[0].allergeni;
    }
    
  }

  nuovpiattopranzo(){
    const newS:any = {
      id:uuid.v4(),
      nome: '',
      tipo:'Primo',
      ingredienti:'<p></p>',
      ricetta_id:null
    };
 
    this.progr.pranzo.unshift(newS);
   
    //Caution: guard again dataKey here
    this.maintablepranzo.editingRowKeys[newS[this.maintablepranzo.dataKey]] = true;
    this.onRowEditInitPranzo(newS);

  }
  
  nuovpiattocena(){
    const newS:any = {
      id:uuid.v4(),
      nome: '',
      tipo:'Primo',
      ingredienti:'<p></p>',
      ricetta_id:null
    };
 
    this.progr.cena.unshift(newS);
   
    //Caution: guard again dataKey here
    this.maintablecena.editingRowKeys[newS[this.maintablecena.dataKey]] = true;
    this.onRowEditInitCena(newS);

  }
  getRicetta(ricetta:any){

    let f=this.ricetteList.filter((x:any)=> x.value==ricetta);
    if((f)&&(f.length>0)){
      return f[0].label;
    } else {
      return '';
    }
  }
  
  getTipo(tipo:any){

    let f=this.tipopiattiList.filter((x:any)=> x.value==tipo);
    if((f)&&(f.length>0)){
      return f[0].label;
    } else {
      return '';
    }
  }
  
}
